export default "__VITE_ASSET__CmcgOH8T__"